/* eslint-disable max-statements */
import $ from 'jquery';
import React from 'react';
import ReactDOM from 'react-dom';
import {pathOr, prop} from 'ramda';
import {View} from 'backbone';
import Moment from 'moment';
import {messageHandler} from '@sinclair-digital/stl-common/src/sinclair/sinclair.uiTools';
import {maybeHead} from '@sinclair-digital/sbg-util/dist/es/list';
import liveAssetsCardTemplate from '../../templates/media/liveAssetsCard.hbs';
import mediaListTemplate from '../../templates/media/mediaListTemplate.hbs';
import {viewMixins} from '@sinclair-digital/stl-common/src/sinclair/sinclair.mixins';
import {clipping} from '../../clipper/clipping';
import {cloneObject, getUrlParameter, setUrlParameters} from '@sinclair-digital/stl-common/src/sinclair/sinclair.utils';
import {beforeMainLoader, completeMainLoader, hideTopLoader} from '@sinclair-digital/stl-common/src/sinclair/sinclair.ajax';
import eventChannels from '@sinclair-digital/stl-common/src/eventChannels';
import ImageEditorView from './imageEditorView';
import VideoEditorView from './videoEditorView';
import clipperUiView from './clipperUiView';
import PackageSortView, {assignSortOptionsFromUrl} from '@sinclair-digital/stl-common/src/views/common/_packageSortView';
import MediaCollection, {uploadToCollection} from '@sinclair-digital/stl-common/src/collections/media/mediaCollection.v2';
import LiveAssetCollection from '@sinclair-digital/stl-common/src/collections/media/liveAssetCollection';
import LiveAssetModel from '@sinclair-digital/stl-common/src/models/media/liveAssetModel';
import BasicSearchFilters from '@sinclair-digital/sbg-storyline-components/src/components/PackageSearch/BasicSearchFilters';
import MediaSearchOptions from '@sinclair-digital/stl-common/src/models/common/mediaSearchOptions';
import {
    defaultOptions,
    getSelectedFilters,
} from '@sinclair-digital/sbg-storyline-components/src/components/PackageSearch/models/mediaSearchOptions';
import PackageBasicSearchView from '@sinclair-digital/stl-common/src/views/common/_packageBasicSearchView';
import {
    assignFieldFiltersFromUrl,
    assignPackageTypeFiltersFromUrl,
    assignScopeOptionsFromUrl,
    assignSearchTextFilterFromUrl,
} from '@sinclair-digital/sbg-storyline-components/src/components/PackageSearch/url';
import {
    getActiveFilters,
} from '@sinclair-digital/sbg-storyline-components/src/components/PackageSearch/selectors';
import {setUpCardSelectorDropdown} from '@sinclair-digital/stl-common/src/sinclair/sinclair.media.utils';
import {logError} from '@sinclair-digital/stl-common/src/analytics/common';
import {uploadMediaInitiated, uploadMediaCompleted, editMediaInitiated} from '@sinclair-digital/stl-common/src/analytics/mediaPackage';
import {sortByCallLetters} from '@sinclair-digital/stl-common/src/collections/common/targetCollection';
import {default as MediaCard} from '@sinclair-digital/sbg-storyline-components/src/components/MediaCard';
import UploadFiles from '@sinclair-digital/sbg-storyline-components/src/components/MediaCard/UploadFiles';
import {bindAllMethods} from '@sinclair-digital/stl-common/src/backboneHelpers';
import {getFeatureFlag} from '@sinclair-digital/sbg-storyline-sdk/lib/storyline/featureFlags';

const myMediaFilterEnabled = () => getFeatureFlag('myMediaFilter');

const sortOptions = [
    {
        sortColumn: 'Date',
        text: 'upload date',
        sortDirection: 'descending',
        selected: true,
    },
];

const _uploadToCollection = uploadToCollection(messageHandler);

const defaultFilterOptions = defaultOptions;

const MediaListView = View.extend(
    Object.assign({}, viewMixins.basicSearch, {
        debuggingName: 'Media List View',
        template: mediaListTemplate,
        el: '#admin-main',
        className: 'sda-MediaListView',
        navId: 'admin-media-tab',
        sdaPageTitle: 'media',
        viewStyle: 'thumbnail-large-view',
        events: {
            'click .sda-media-link': '_mediaClickHandler',
            'click .sda-view-menu-options': '_viewToggleItemClickHandler',
            'change.val #thumb-type': '_viewToggleItemClickHandler',
            'change .sda-media-all-library-checkbox': '_selectAllCheckboxes',
            'click .media-toggle': '_toggleMediaUploadFooter',
            // basic search
            'change.sort .js-sda-PackageSort': 'sendQuery',

            'click #upload-button': '_uploadButtonHandler',
            'drop .media-file-attach-input': '_uploadDropHandler',
            'dragover .media-file-attach-input': '_uploadDragoverHandler',
            'dragover footer': '_uploadDragoverHandler',
            'dragenter .media-file-attach-input': '_uploadDragoverHandler',
            'dragover .content-media': '_uploadDragoverHandler',
            'dragenter .content-media': '_uploadDragoverHandler',

            'change .media-file-attach-input': '_uploadFileHandler',
            'click .sda-media-save-one': '_saveOneHandler',
        },
        // eslint-disable-next-line complexity
        initialize(opts) {
            this.user = this.userModel.getFullName();
            this.collection = new MediaCollection();
            this.collection.uploads = new MediaCollection();
            this.liveAssetCollection = new LiveAssetCollection();

            this.checkedBoxes = []; // Used to keep track of "checked" <MediaCard /> Components - needed while mediaListView is still in Backbone
            this.isChecked = false;
            this.uploadedAssets = [];
            this.packages = [];

            let fromStr = getUrlParameter('dateFrom')[0];
            let thruStr = getUrlParameter('dateThru')[0];

            if (typeof fromStr !== 'undefined') {
                fromStr = decodeURIComponent(fromStr);
            }

            if (typeof thruStr !== 'undefined') {
                thruStr = decodeURIComponent(thruStr);
            }

            let scopeFilters = assignScopeOptionsFromUrl(defaultFilterOptions.scope).filters;
            const activeScopeFilter = getActiveFilters(scopeFilters);

            if (!activeScopeFilter || activeScopeFilter.length <= 0) {
                scopeFilters = defaultFilterOptions.scope.filters;
            }

            const myMedia = getUrlParameter('myMedia')[0];

            this.searchOptions = new MediaSearchOptions({
                searchText: assignSearchTextFilterFromUrl(defaultFilterOptions.searchText),
                fromDate: fromStr ? Moment(fromStr).toDate() : null,
                thruDate: thruStr ? Moment(thruStr).toDate() : null,
                scopeFilters,
                packageTypeFilters: assignPackageTypeFiltersFromUrl(defaultFilterOptions.packageType).filters,
                fieldFilters: assignFieldFiltersFromUrl(defaultFilterOptions.field).filters,
                myMedia,
            });

            this.stations = this.userModel
                .get('availableTargets')
                .toJSON()
                .sort(sortByCallLetters);
            const channels = this.stations.map(target => ({
                name: `${target.site.callLetters} - Broadcasts`,
                value: target.site.callLetters,
            }));


            // TODO change this to use a look up table (similar to livestreamTargetMap.js in stl-common)
            const hasKganAccess = channels.some(target => target.value === 'KGAN');
            if (hasKganAccess) {
                channels
                    .push({
                        name: 'QGAN - Broadcasts',
                        value: 'QGAN',
                    });

                channels.sort((a,b) => a.value > b.value ? 1 : -1);
            }

            const callLetters = getUrlParameter('channel')[0] || pathOr('', ['0', 'value'], channels);
            this.searchOptions.setBroadcastChannelList(channels);
            this.searchOptions.setBroadcastChannel(callLetters);

            this.listenTo(eventChannels.media.imageEditor, 'save', this._closeImageEditingInterface);
            this.listenTo(eventChannels.media.imageEditor, 'cancel', this._closeImageEditingInterface);
            this.listenTo(eventChannels.media.videoEditor, 'save.success', this._closeVideoEditor);
            this.listenTo(eventChannels.media.videoEditor, 'cancel', this._closeVideoEditor);
            this.listenTo(eventChannels.media.videoEditor, 'done.clipping', this._closeVideoEditor);

            $(document).bind('keydown', event => clipping.videoKeydown(event));
            $(document).bind('keyup', event => clipping.videoKeyup(event));
            $(document).bind('click', event => this._viewToggleClickHandler(event));

            bindAllMethods(this);

            const searchMode = getUrlParameter('type')[0];

            // Bugfix for, https://jira.sinclairstoryline.com:8443/browse/NPL-1124
            if (searchMode === 'broadcast') {
                const packageType = this.searchOptions.get('packageType');
                this.searchOptions.set(
                    'packageType',
                    {
                        ...packageType,
                        filters: packageType.filters.map(
                            // eslint-disable-next-line no-unused-vars
                            ({selected, ...pt}) => pt.name === 'broadcast' ? ({...pt, selected: true}) : pt
                        ),
                    }
                );
            }

            this.render(opts);
            this._initChildViews();
            this._setUpModals();
            this.uploadFiles();

            setUpCardSelectorDropdown.call(this, '#thumb-type', '.sda-card-list');

            this.selectFilter(searchMode);

            this.listenTo(this.searchOptions, 'change', this.onSearchOptionsChange);
        },
        render(opts) {
            this.$el.html(this.template()).sdaInitWidgets();

            if (opts.upload) {
                this._uploadFileHandler({target: {files: opts.files}});
            }

            return this;
        },
        onSearchOptionsChange() {
            this._filterChangeHandler();
            this.renderSearchFilters();
            if (this.checkedBoxes.length) {
                this.checkedBoxes.splice(0);
                this._toggleBulkAction();
            }
        },
        renderSearchFilters() {
            ReactDOM.render(
                // eslint-disable-next-line react/jsx-filename-extension
                <BasicSearchFilters
                    searchOptions={this.searchOptions.toJSON()}
                    showScopeOptions={true}
                    showMyMediaOptions={myMediaFilterEnabled()}
                    onOptionsChange={opts => this.searchOptions.set(opts)}
                />,
                document.querySelector('#js-sda-BasicSearchFilter'),
            );
        },
        _initChildViews() {
            this.basicSearchView = new PackageBasicSearchView({
                type: 'media',
                searchOptions: this.searchOptions,
            });

            this.sortView = new PackageSortView({
                sortOptions: assignSortOptionsFromUrl(sortOptions),
            });

            this.renderSearchFilters();

            this.imageEditor = new ImageEditorView({
                el: '#image-editor-fly-over',
            });

            this.videoEditor = new VideoEditorView({
                el: '#video-editor-fly-over',
            });

            this._$scrollContainer = this.$('.sda-media-card-list-container');

            this.subViews = [this.basicSearchView, this.sortView, this.imageEditor, this.videoEditor];

            if (getFeatureFlag('clipperUi')) {
                // VSE-3895: POC for component-as-plugin to replace clipping view for broadcast assets
                this.clipperUi = new clipperUiView({
                    el: '#clipper-ui-fly-over',
                });
                this.subViews.push(this.clipperUi);
            }
        },

        destroy() {
            $(document).off('keydown', event => clipping.videoKeydown(event));
            $(document).off('keyup', event => clipping.videoKeyup(event));
            $(document).off('click', event => this._viewToggleClickHandler(event));
        },

        _isVideo: mediaJson => mediaJson.mediaType === 'video',
        _videoIsProcessing: videoJson =>
            videoJson.videoStatus !== 'READY' && videoJson.videoStatus !== null && videoJson.status !== 'uploading',
        _convertVideoStatusToStatus(modelJson) {
            const newModelJson = cloneObject(modelJson);

            newModelJson.status = modelJson.videoStatus;

            return newModelJson;
        },

        resetPackageList(packages) {
            this.packages = packages;
            this.renderCards();

            return packages;
        },

        appendPackages(packages) {
            this.packages = (this.packages || []).concat(packages);
            this.renderCards();

            return packages;
        },

        /**
         * Renders the media cards using the React Dom
         * @param  {array} packages Array of mediaCard Data taken from search
         * @returns {null} null
         */
        renderCards() {
            ReactDOM.render(
                <div>
                    {this.packages.map(data => (
                        <MediaCard
                            key={data.uuid}
                            data={data}
                            viewStyle={this.viewStyle}
                            checkComponentBox={this.checkComponentBox}
                            mediaClickHandler={this._mediaClickHandler}
                            isCheckable={this.isCheckable}
                        />
                    ))}
                </div>,
                this._$packageList[0],
            );
        },

        isCheckable() {
            return this.userModel.userHasPermissionSet('media.delete');
        },

        removeCheckboxes(html) {
            const $html = $(html);

            if (!this.userModel.isAdmin()) {
                $html.find('.sda-media-checkbox').remove();
            }

            return $html[0];
        },

        _filterChangeHandler() {
            const packageTypeFilters = getSelectedFilters('packageType', this.searchOptions.attributes);
            const filterName = maybeHead(packageTypeFilters)
                .map(prop('name'))
                .getOrElse('');
            this.selectFilter(filterName);
        },
        selectFilter(val = '') {
            if (val.toUpperCase() !== 'BROADCAST') {
                this.sortView.$el.show();
                this._$scrollContainer.off('scroll', this._checkScrollPosition);
                this._$scrollContainer.on('scroll', this._checkScrollPosition);

                this.sendQuery();
            } else {
                this.sortView.$el.hide();
                this._$scrollContainer.off('scroll', this._checkScrollPosition);

                const callLetters = this.searchOptions.getSelectedBroadcast();
                this._liveAssetFetch(callLetters);
            }
        },

        sendQuery() {
            if (this._$packageList.length > 0) {
                ReactDOM.unmountComponentAtNode(this._$packageList[0]);
            }
            this._sendQuery();
        },

        // NPL-1575 Media Search Improvement - multiple string search
        // override viewMixins.basicSearch's method because we only want the feature flagged version in this view
        _getSearchText(query) {
            return getFeatureFlag('useMultiStringMediaSearch') ?
                query.searchText.text.split(' ') :
                viewMixins.basicSearch._getSearchText(query);
        },

        _mediaClickHandler(e, id) {
            e.preventDefault();
            e.stopPropagation();
            const $caller = $(e.currentTarget).closest('.sda-card-media');
            const uuid = $caller.attr('id') || id;
            let model = this.collection.findWhere({uuid});
            let getModel;

            // unselect checkbox associated with Card
            this.checkedBoxes = this.checkedBoxes.filter(cbId => cbId !== uuid);
            this.packages = this.packages.map(item => item.uuid === uuid ? {...item, isChecked: false} : item);

            if ($caller.data('type') === 'broadcast') {
                model = this.liveAssetCollection.get(uuid);
                model = new LiveAssetModel({
                    video: {
                        title: model.get('desc'),
                        alt: model.get('desc'),
                        original: 'true',
                        updatedBy: this.user,
                        metadata: '',
                        type: 'Video',
                        caption: model.get('desc'),
                        created: model.get('created'),
                        drm: '0',
                        version: '1',
                        attributes: [],
                        thumbUrl: model.get('thumb_url'),
                        url: model.get('signedUrl'),
                        uuid: model.id,
                        externalId: model.id,
                        description: model.get('desc'),
                        duration: model.get('duration'),
                        thumbnailUrls: model.get('thumbnails_url'),
                        isLive: model.get('is_live') === 'true',
                        mediaType: 'video',
                    },
                    tags: [],
                    originalExternalId: model.id,
                    inpoint: 0,
                    outpoint: model.get('duration'),
                });

                model.isNewscast = true;
                model.id = model.get('video').uuid;

                // VSE-3895: POC for component-as-plugin to replace clipping view for broadcast assets
                if (window.__sbgModules._baseModules.clipperUi?.provides?.getIsAllowedAccessWithFlag?.('clipperUi')) {
                    try {
                        // attempt to mount clipper ui
                        this.clipperUi.render(model);
                        return;
                    } catch (error) {
                        // log error & continue to mount legacy interface
                        // eslint-disable-next-line no-console
                        console.error(error);
                    }
                }

                this.videoEditor.render(model);
                this.basicSearchView.$el.hide();
            } else {
                if (!model) {
                    model = this.collection.uploads.findWhere({uuid});
                }

                if (model) {
                    getModel = Promise.resolve(model);
                    beforeMainLoader();
                    getModel
                        .then(model => {
                            const mediaType = model.get('mediaType');
                            if (mediaType !== 'audio') {
                                $('body').addClass('hide-nav');
                                $('.sda-nav-panel').removeClass('panel-open');

                                if (mediaType === 'image') {
                                    this.imageEditor.setElement(this.imageEditor.$el).render(model);
                                    this.imageEditor.$el.open();
                                } else {
                                    this.videoEditor.render(model);
                                }
                                this.basicSearchView.$el.hide();
                            }
                            completeMainLoader();
                            editMediaInitiated(model.get('mediaType'), uuid);
                        })
                        .catch(err => {
                            console.error(err);
                            messageHandler(
                                'error',
                                'There was an issue prepping the media for editing',
                                'If the problem persists, try re-uploading the media',
                            );
                            logError({message: `Can't initiate edit for ${uuid}`});
                            completeMainLoader();
                        });
                }
            }

            return false;
        },
        _closeImageEditingInterface(modelData) {
            if (modelData) {
                this._redrawMediaCard(modelData);
            }
            this.imageEditor.$el.close();
            this.basicSearchView.$el.show();

            // if other media is selected, display bulk action button. otherwise, hide it
            this._toggleBulkAction();
        },

        _renderMediaUploadCard(data) {
            this.uploadedAssets.push(data);
            this.uploadFiles();
        },

        uploadFiles() {
            const uploadList = this.$('.sda-media-session-list');
            ReactDOM.render(
                <UploadFiles
                    uploadedAssets={this.uploadedAssets}
                    viewStyle={this.viewStyle}
                    checkComponentBox={this.checkComponentBox}
                    mediaClickHandler={this._mediaClickHandler}
                    isCheckable={this.isCheckable()}
                />,
                uploadList[0],
            );
        },

        _redrawMediaCard(modelData) {
            if (modelData.hasOwnProperty('uuid')) {
                this.packages.forEach((item, i) => {
                    if (item.uuid === modelData.uuid) {
                        this.packages[i] = modelData;
                    }
                });

                this.renderCards(); // Send the updated package array to the React render
            } else {
                console.error('No UUID present on: %o', modelData); // eslint-disable-line no-console
            }
        },
        _uploadButtonHandler() {
            this.$('#main-media-upload').click();
        },
        _uploadFileHandler(e) {
            const target = e.dataTransfer || e.target,
                files = target && target.files && target.files;

            uploadMediaInitiated();
            this._createUploadCards(files);
            this.$('footer.admin-story-media').addClass('media-show media-hint');

            _uploadToCollection(this.collection, target, ({media}) => {
                this._handleFileUploadEnd(media);

                if (media) {
                    uploadMediaCompleted(media.mediaType, media.uuid);
                }
            });
        },
        _handleFileUploadEnd(modelData = null) {
            this.$('.sda-media-session-list')
                .find('article.uploading')
                .remove();
            if (modelData != null) {
                this.collection.uploads.add(modelData);
            }
            this.collection.uploads.toJSON().forEach(model => {
                if (['video', 'audio'].includes(model.mediaType)) {
                    // clipped videos have a status of null
                    if (model.videoStatus !== 'READY' && model.videoStatus !== null) {
                        model.status = model.videoStatus;

                        this.collection.uploads
                            .findWhere({uuid: model.uuid})
                            .monitorStatus()
                            .then(this._updateVideoCardStatus.bind(this))
                            .catch(err => {
                                if (err === this.collection.findWhere({uuid: model.uuid})) {
                                    return false;
                                } else {
                                    console.error('There was an error getting video status: %o', err);
                                }
                            });
                    }
                }

                const accountedFor = this.uploadedAssets.some(obj => {
                    return obj.uuid === model.uuid;
                });

                if (!accountedFor) {
                    this._renderMediaUploadCard(model);
                }
            });

            const pendingUploads = this.collection.getPendingUploads();
            if (pendingUploads) {
                pendingUploads.forEach(model => {
                    model.status = 'uploading';
                    this._renderMediaUploadCard(model);
                });
            }
        },
        _toggleMediaUploadFooter() {
            if (this.$('.sda-media-session-list article').length > 1) {
                this.$('.admin-story-media').toggleClass('media-show');
            } else {
                this.$('.admin-story-media').toggleClass('media-show');
            }

            this.$('.app-content').toggleClass('media-show');
        },
        _closeVideoEditor(modelData) {
            if (getUrlParameter('type')[0] === 'broadcast'){
                this._renderBroadcasts();
            } else if (modelData) {
                // Override data if modelData is returned
                this._redrawMediaCard(modelData);
            } else {
                this.renderCards();
            }
            this.videoEditor.$el.close();
            this.basicSearchView.$el.show();

            // if other media is selected, display bulk action button. otherwise, hide it
            this._toggleBulkAction();
        },
        _updateVideoCardStatus(model) {
            const modelData = model.toJSON(),
                status = modelData.videoStatus,
                mediaTypeText = modelData.mediaType.toUpperCase();

            if (status !== 'READY' && status !== 'ERROR') {
                model.monitorStatus().then(this._updateVideoCardStatus.bind(this));
                modelData.status = status;
            } else if (status === 'READY') {
                messageHandler('success', `${mediaTypeText} PROCESSING COMPLETED`, modelData.title);
            } else if (status === 'ERROR') {
                messageHandler('error', `AN ERROR OCCURRED WHILE PROCESSING THE ${mediaTypeText}`, modelData.title);
            }

            this.$('.sda-media-session-list')
                .find('article.PENDING')
                .eq(0)
                .remove();
            this._renderMediaUploadCard(modelData);
        },
        _createUploadCards(files) {
            this.collection.getAllFileMetadata(files).then(fileDataArray => {
                fileDataArray.forEach(fileData => {
                    fileData.status = 'uploading';
                    this._renderMediaUploadCard(fileData);
                });
            });

            return Promise.resolve(files);
        },
        _deleteHandler(uuid) {
            let model = this.collection.findWhere({uuid});

            if (!model) {
                model = this.collection.uploads.findWhere({uuid});
            }

            if (model) {
                model
                    .destroy()
                    .then(() => {
                        $(`#${uuid}`).remove();
                        this.checkedBoxes = this.checkedBoxes.filter(box => box !== uuid);
                    })
                    .fail((xhr, data) => {
                        messageHandler('error', 'Cannot delete selected media.');
                        console.warn(data);
                    });
            }
        },

        _setUpModals() {
            $('#sda-remove-selected').sdaModal({
                title: 'Delete all selected images',
                message: 'Are you sure you want to delete all selected media?',
                savetext: 'continue',
                canceltext: 'back',
                toggle: 'sda-confirm',
                onSave: () => {
                    for (const id of this.checkedBoxes) {
                        this._deleteHandler(id);
                    }

                    $('.sda-bulk-action-btn').removeClass('show-bulk-actions');
                },
            });
        },
        _liveAssetFetch(callLetters) {
            if (this.collection.fetchIsPending()) {
                this.collection.abortSearch();
                hideTopLoader();
            }

            setUrlParameters({
                type: 'broadcast',
                channel: callLetters,
            });

            this.liveAssetCollection.reset();
            this.liveAssetCollection
                .fetch({
                    url: '/api/video/assetsByChannel/' + callLetters,
                    beforeSend: () => {
                        beforeMainLoader();
                    },
                })
                .then(() => {
                    completeMainLoader();
                    this._renderBroadcasts();
                })
                .fail(err => {
                    const message = 'There was an error fetching broadcasts for ' + callLetters;
                    let message2 = '';

                    if (err && err.message) {
                        message2 = err.message;
                    }

                    completeMainLoader();
                    messageHandler('error', message, message2);
                    console.error(err);
                });
        },
        _renderBroadcasts() {
            if (!this._$packageList) {
                this._$packageList = this.$('.package-list');
            }
            let collection = this.liveAssetCollection.toJSON();
            if (getFeatureFlag('videoNexus_cardIcons:enabled')) {
                // Add boolean to each broadcast for handlebars template use
                collection = collection.map(broadcast => {
                    broadcast.isVideoNexus = broadcast.type === 'HMS_AWS';
                    return broadcast;
                });
            }
            this._$packageList.html(liveAssetsCardTemplate(collection));
        },
        /*
         * Save one (individual) event handler for upload panel
         */
        _saveOneHandler(e) {
            const $caller = $(e.target);
            const $parent = $('#' + $caller.data('uuid'));

            $parent.animate(
                {
                    opacity: 0,
                },
                500,
                () => {
                    $parent.remove();
                },
            );
            // Saved Message
            return false;
        },

        /**
         * Toggles the bulk action buttons visibility
         * @returns {null} null
         */
        _toggleBulkAction() {
            if (this.checkedBoxes.length) {
                $('.sda-bulk-action-btn').addClass('show-bulk-actions');
            } else {
                $('.sda-bulk-action-btn').removeClass('show-bulk-actions');
            }
        },

        /**
         * Checks the checkbox in the mediaCard component
         * @param  {Boolean} isChecked passed in from react component to see if checked or not
         * @param  {String}  uuid - id of component
         * @returns {null} null
         */
        checkComponentBox(isChecked, uuid, event) {
            event && event.preventDefault();
            event && event.stopPropagation(); //fixes a bug where this event is handled twice
            if (isChecked) {
                this.checkedBoxes = [...this.checkedBoxes, uuid];
            } else {
                this.checkedBoxes = this.checkedBoxes.filter(cbId => cbId !== uuid);
            }

            // If not all boxes are checked in the list, uncheck the master box
            // List View Only
            if (this.packages.length !== this.checkedBoxes.length) {
                this._uncheckMasterCheckbox();
            }

            this._toggleBulkAction();

            this.packages = this.packages.map(item => item.uuid === uuid ? {...item, isChecked} : item);

            this.uploadedAssets.forEach(item => {
                if (item.uuid === uuid) {
                    item.isChecked = isChecked;
                }
            });

            this.renderCards();
            this.uploadFiles();
        },

        _uploadDropHandler(e) {
            this.$('#uploader').removeClass('dragging');
            this._uploadFileHandler(e.originalEvent);
            e.originalEvent.stopPropagation();
            e.originalEvent.preventDefault();
        },
        _uploadDragoverHandler(evt) {
            const e = evt.originalEvent;
            e.stopPropagation();
            e.preventDefault();
            e.dataTransfer.dropEffect = 'copy';
            this.$('#uploader').addClass('dragging');
            this.$('footer').addClass('media-show media-hint');
        },
        _uploadDragleaveHandler(evt) {
            const e = evt.originalEvent;
            e.stopPropagation();
            e.preventDefault();

            if (this.$('.sda-media-session-list article').length > 1) {
                this.$('footer').removeClass('media-show');
            } else {
                this.$('footer').removeClass('media-show media-hint');
            }

            this.$('.sda-file-uploader').removeClass('dragging');
        },

        _viewToggleItemClickHandler(e, className) {
            const $parent = this.$('#thumb-type');
            const $targets = this.$('.sda-media-list-headers, .sda-card-list');
            const classes = ['thumbnail-large-view', 'thumbnail-medium-view', 'thumbnail-small-view', 'list-view'];

            $targets.removeClass(classes.join(' '));
            $targets.addClass(className);

            this.viewStyle = className;
            this.renderCards();

            $parent.find('.sda-select-list').toggleOpen();

            return false;
        },

        _viewToggleClickHandler(event) {
            const $parent = this.$('#thumb-type');
            const $buttonContainer = $parent.find('.sda-btn-icon');
            const $buttonIcon = $buttonContainer.find('.fa-eye');
            if ((event.target !== $buttonContainer[0]) && (event.target !== $buttonIcon[0])) {
                const $viewMenu = this.$('.sda-select-list');
                if ($viewMenu.hasClass('list-open')) {
                    $parent.find('.sda-select-list').toggleOpen();
                }
            }
        },

        _selectAllCheckboxes(e) {
            const $masterCheckbox = this.$(e.target);
            const isChecked = $masterCheckbox.is(':checked');

            this.packages.forEach((item, i) => {
                this.packages[i].isChecked = isChecked;
                if (isChecked) {
                    this.checkedBoxes.push(this.packages[i].uuid);
                } else {
                    this.checkedBoxes = [];
                }
            });

            this._toggleBulkAction();
            this.renderCards();
        },

        _uncheckMasterCheckbox() {
            this.$('#checkbox-library-all').prop('checked', false);
        },
    }),
);

export default MediaListView;
